module.exports = __webpack_public_path__ + "static/media/Beardhemian Brushsody.e70abcc2.png";